export default __webpack_public_path__ + "static/1000-2de552dc70c2cdf7f6ec82a2d3bd14ad.gif";